import { useState } from "react";
import { Megaphone, Monitor } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function CallButton({ kind, item, code, onDone, testId }) {
  const [busy, setBusy] = useState(false);
  const call = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/calls", { kind, ref_id: item.id });
      toast.success(`Senha ${data.code} chamada no painel`);
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Button size="sm" disabled={busy} onClick={call} className="w-full bg-amber-400 text-slate-950 hover:bg-amber-300 transition-colors" data-testid={testId}>
      <Megaphone className="h-4 w-4 mr-1" />{item.called_at ? "Chamar de novo" : "Chamar senha"} <span className="ml-1 font-mono font-bold">{code}</span>
    </Button>
  );
}

export function PanelLink({ slug }) {
  return (
    <Button asChild variant="outline" data-testid="open-call-panel-btn">
      <a href={`/chamada/${slug}`} target="_blank" rel="noreferrer"><Monitor className="h-4 w-4 mr-1" />Painel de senhas</a>
    </Button>
  );
}
